export const STATE_KEY = 'drive';

export const GET_FOLDERS_LIST = `${STATE_KEY}/GET_FOLDERS_LIST`;
export const STORE_FOLDER_LIST = `${STATE_KEY}/STORE_FOLDER_LIST`;
export const SET_LOADERS = `${STATE_KEY}/SET_LOADERS`;
export const SET_CURRENT_FOLDER = `${STATE_KEY}/SET_CURRENT_FOLDER`;
export const SET_CURRENT_FOLDER_ID = `${STATE_KEY}/SET_CURRENT_FOLDER_ID`;
export const SET_GLOBAL_FILTERS = `${STATE_KEY}/SET_GLOBAL_FILTERS`;
export const RESET_GLOBAL_FILTERS = `${STATE_KEY}/RESET_GLOBAL_FILTERS`;
